<template>
    <div class="form-default" v-if="options != null">
        <form class="form_call" v-if="formVisible">
            {{options}}
            <div class="form-in">
                <div class="form-group form-city">
                    <input type="text" name="city" class="form-control" :placeholder="options.formParams.city" v-model="city" v-validate="{required: true}"  data-vv-delay="1000">
                </div>
                <div class="form-group form-name">
                    <input type="text" name="name" class="form-control" :placeholder="options.formParams.name" v-model="name" v-validate="{required: true}"  data-vv-delay="1000">
                </div>
                <div class="form-group form-phone">
                    <masked-input v-model="phone" mask="\+\7 (111) 111-11-11" placeholder="+7 (" class="form-control" name="phone" v-validate="{ required: true, regex: regexRules.phone }" data-vv-delay="1000"/>
                </div>
                <div class="btn-send">
                    <button class="btn btn-submit btn-success" type="button" @click="sendData" :disabled="errors.any()">{{options.formParams.btn}}</button>
                </div>
            </div>
        </form>
        <div class="successMessage" v-else>
            <h3>{{options.formParams.msg}}</h3>
        </div>
    </div>
</template>

<script>
    import MaskedInput from 'vue-masked-input'
    import {mapGetters} from 'vuex'
    export default {
        name: 'FormFields',
        props: ['options'],
        data () {
            return {
                phone: '',
                name: '',
                city: '',
                admin_mail: 'newcrm_bazis@mail.ru',
                agree: false,
                formVisible: true,
                regexRules: {
                    name: /^([а-яА-ЯёЁa-zA-Z].*[\s\.]*){3,35}$/,
                    phone: /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{10,10}$/,
                    mail: /[a-zA-Z0-9_\.\+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-\.]+/
                }
            }
        },
        components: {
            MaskedInput,
        },
        computed: mapGetters({
        }),
        methods: {
            sendData() {
                var querystring = require('querystring');
                var data = {
                    'email': this.admin_email,
                    'name': this.name,
                    'phone': this.phone,
                    'city': this.city,
                };
                // console.log(JSON.stringify(data));
                this.$validator.validate().then(result => {
                    if(result) {
                        this.formVisible = false
                        axios.post('/formSend.php',querystring.stringify(data)).then(() => {
                            // console.log('asdasdasd')
                            dataLayer.push({'event' : 'form_sent'})
                        });
                        $.ajax({
                            url: "https://docs.google.com/forms/d/e/1FAIpQLScyyvcnLRVtk66v9LAYWhHDHvXlSzglUuCb0mzmbmUB2nAo1g/formResponse",
                            data: {
                                // name
                                "entry.529026930": this.name,
                                // phone
                                "entry.667490947": this.phone,
                                // city
                                "entry.971432211": this.city
                            },
                            type: "POST",
                            dataType: "xml"
                        });
                    } else {
                        console.log('Form inputs with errors');
                    }
                });
            }
        },
        created () {
            
        },
        mounted () {
            // this.$store.watch(
            //     (state) => state.forms,
            //     (newValue) => {
            //         if (newValue)
            //         this.admin_mail = this.form.admin_email
            //     }
            // )
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/forms/form.scss';
    // @import '@/styles/components/forms/forms-respond/form-respond.scss';
</style>